module.exports = __webpack_public_path__ + "img/advantageimg.9124c783.png";